var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoginIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.75195 22.4982L30.002 22.4982M30.002 22.4982L23.4395 16.8732M30.002 22.4982L23.4395 28.1232",
    stroke: "#1C274C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8789 13.125C16.9016 9.04683 17.0825 6.83824 18.5232 5.39752C20.1707 3.75 22.8223 3.75 28.1256 3.75L30.0006 3.75C35.3039 3.75 37.9556 3.75 39.6031 5.39752C41.2506 7.04505 41.2506 9.6967 41.2506 15L41.2506 30C41.2506 35.3033 41.2506 37.955 39.6031 39.6025C37.9556 41.25 35.3039 41.25 30.0006 41.25H28.1256C22.8223 41.25 20.1707 41.25 18.5232 39.6025C17.0825 38.1618 16.9016 35.9532 16.8789 31.875",
    stroke: "#1C274C",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginIcon);
export default __webpack_public_path__ + "static/media/LoginIcon.6112c99cc591f3c7fb6f926ab3a89f80.svg";
export { ForwardRef as ReactComponent };